export default async function fetchUser() {
	const db = R.surreal?.db
	if (!db) {
		log.error('SurrealDB connection is not available')
		return
	}

	const startTime = log.start()

	try {
		const user = await db.info()

		if (user) {
			await R.db.states.auth.set('user', () => user)
			log.info('SurrealDB user fetched')
		} else {
			log.error('No user data returned from SurrealDB')
		}
	} catch (e: any) {
		log.error('Failed to fetch SurrealDB user', e.message)
	}

	log.end('Fetch SurrealDB user', startTime)
}
